import { render, staticRenderFns } from "./ProofOfEnrollment.vue?vue&type=template&id=3be6e79f&scoped=true&"
import script from "./ProofOfEnrollment.vue?vue&type=script&lang=js&"
export * from "./ProofOfEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfEnrollment.vue?vue&type=style&index=0&id=3be6e79f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be6e79f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
